import { FilterOperators, FilterTypes } from "@/data/table";
import { IFilter, IFiltersOptions } from "@/models/tables";
import { TransactionStatus } from "@/data/constants";
import { DataModules } from "@/store/modules/data";
import { IClient } from "@/models/clients";
import { UUID } from "@/data/enums";
import _ from "@/boot/lodash";
import store from "@/store";
import i18n from "@/i18n";

export async function getGateways(): Promise<IFiltersOptions[]> {
  try {
    const gateways = await store.dispatch(`data/${DataModules.GATEWAYS}/list`, {
      params: {
        brand_id: UUID.UPMIND // Get all available gateways supported by Upmind
      },
      storeData: false
    });
    return Promise.resolve(
      _.map(_.isArray(gateways) ? gateways : [], g => ({
        value: g.name,
        label: g.name
      }))
    );
  } catch {
    return Promise.resolve([]);
  }
}

export function TransactionFilters(config: {
  statuses: TransactionStatus[];
  clientId?: IClient["id"];
}): IFilter[] {
  const statuses = config.statuses || [];
  const clientId = config.clientId;

  const filters = [
    {
      key: "transaction_id",
      label: i18n.t("_.transaction"),
      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL
    },
    {
      key: "gateway.name",
      label: i18n.t("_.payment_gateway"),
      type: FilterTypes.SELECT_CHECKBOX,
      operator: FilterOperators.EQUAL,
      optionsFunc: getGateways
    },
    {
      key: "amount",
      label: i18n.t("_.total"),
      type: FilterTypes.NUMBER,
      operator: FilterOperators.EQUAL
    },
    {
      key: "status",
      label: i18n.t("_.status"),
      type: FilterTypes.SELECT_CHECKBOX,
      options: _.filter(
        [
          { value: TransactionStatus.OK, label: i18n.t("_.ok") },
          {
            value: TransactionStatus.ERROR,
            label: i18n.t("_.error")
          },
          {
            value: TransactionStatus.CONFIRMED,
            label: i18n.t("_.confirmed")
          },
          {
            value: TransactionStatus.EXPIRED,
            label: i18n.t("_.expired")
          },
          {
            value: TransactionStatus.FRAUD,
            label: i18n.t("_.fraud")
          },
          {
            value: TransactionStatus.REDIRECT,
            label: i18n.t("_.redirect")
          },
          {
            value: TransactionStatus.THREE_D_AUTH,
            label: i18n.t("_.3d_auth")
          },
          {
            value: TransactionStatus.WAITING,
            label: i18n.t("_.waiting")
          }
        ],
        option => (statuses.length ? statuses.includes(option.value) : true)
      ),
      value: [],
      operator: FilterOperators.EQUAL
    },
    {
      key: "created_at",
      label: i18n.t("_.created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  if (clientId === null) {
    filters.splice(
      0,
      0,
      {
        key: "client.firstname",
        label: i18n.t("_.client_firstname"),
        type: FilterTypes.STRING,
        operator: FilterOperators.EQUAL
      },
      {
        key: "client.lastname",
        label: i18n.t("_.client_lastname"),
        type: FilterTypes.STRING,
        operator: FilterOperators.EQUAL
      },
      {
        key: "client.email",
        label: i18n.t("_.client_email"),
        type: FilterTypes.STRING,
        operator: FilterOperators.EQUAL
      }
    );
  }

  return filters;
}
